import { Button, Card, Flex, Heading, Text } from '@radix-ui/themes'
import { Link, useOutletContext } from '@remix-run/react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LuPackageOpen } from "react-icons/lu";
import {
	CART_I18NEXT,
	CART_TEST_ID,
} from '~/routes/($lang).cart/cart.component'
import { type Context } from '~/routes/_layout/root.component'

/* -------------------------------------------------------------------------------------------------
 * NoItems
 * -----------------------------------------------------------------------------------------------*/

const NoItems: React.FC = () => {
	const { locale, setApp } = useOutletContext<Context>()
	const { t } = useTranslation(CART_I18NEXT.routeCart)

	return (
		<Card size="4" data-test-id={CART_TEST_ID.cartEmpty}>
			<Flex
				direction="column"
				justify="center"
				align="center"
				gapY="5"
				flexGrow="1"
			>
				<Flex
					justify="center"
					align="center"
					width="6rem"
					height="6rem"
					className="rounded-full border border-dashed border-accent-8 bg-gray-4"
				>
					<Text color="gray">
            <LuPackageOpen size="2.2em" />
          </Text>
				</Flex>
				<Heading as="h2" align="center" color="gray">
					{t('noItems.common.title')}
				</Heading>
				<Link
					to={`/${locale}/products`}
					prefetch="viewport"
					onClick={() =>
						setApp((prev) => ({
							...prev,
							displaySidebar: false,
						}))
					}
				>
					<Button size="3" variant="surface">
						{t('noItems.button.products')}
					</Button>
				</Link>
			</Flex>
		</Card>
	)
}
NoItems.displayName = 'NoItems'

/* -----------------------------------------------------------------------------------------------*/

export { NoItems }
